// extracted by mini-css-extract-plugin
export default {"container":"GuidesQuickSearch_container__hDu2B","searchIcon":"GuidesQuickSearch_searchIcon__HgjvC"};